import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import LoadingOverlay from "react-loading-overlay-ts";

// MUI Imports
import { Typography, Box, Card, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Iconify from "../../../Components/Dashboard/Iconify.js";
import { getTrainerById } from "../../../Api/trainersApi.js";
import AdminFormStepper from "../../../Components/TrainerSetUp/AdminFormStepper";
import Step1Component from "../../../Components/TrainerSetUp/Components.jsx/Step1Component";
import Step2Component from "../../../Components/TrainerSetUp/Components.jsx/Step2Component";
import Step3Component from "../../../Components/TrainerSetUp/Components.jsx/Step3Component";
import Step4Component from "../../../Components/TrainerSetUp/Components.jsx/Step4Component";
import { Link } from "react-router-dom";

const ViewTrainer = () => {
  const [trainers, setTrainers] = useState([]);
  const [skillCenterEquipments, setSkillCenterEquipments] = useState([]);
  const [skillCenterCourseContents, setSkillCenterCourseContents] = useState(
    []
  );
  const [Comment, setComment] = useState("");
  const [textFieldName, setTextFieldName] = useState("");
  const [commentErr, setCommentErr] = useState({
    state: false,
    msg: "",
    stateTwo: false,
    msgTwo: "",
    stateThree: false,
    msgThree: "",
  });

  const handleCommentChange = (event) => {
    setComment(event.target.value);
    setCommentErr("");
    setTextFieldName(event.target.name);
  };

  const showCommentError = () => {
    setCommentErr({
      state: true,
      msg: "Please fill in a comment",
    });
  };
  const showComment2Error = () => {
    setCommentErr({
      stateTwo: true,
      msgTwo: "Please fill in a comment",
    });
  };
  const showComment3Error = () => {
    setCommentErr({
      stateThree: true,
      msgThree: "Please fill in a comment",
    });
  };
  const removeCommentError = () => {
    setCommentErr({
      state: false,
      msg: "",
      stateTwo: false,
      msgTwo: "",
      stateThree: false,
      msgThree: "",
    });
  };
  //custom css
  const grayedOutStyles = {
    backgroundColor: "#f0f0f0",
    color: "black !important",
    cursor: "not-allowed",
  };
  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up("sm"));

  const trainersReducer = (state) => state.trainersReducer;
  const { currentTrainerId } = useSelector(trainersReducer);

  useEffect(() => {
    const fetchTrainerData = async () => {
      try {
        if (Number.isInteger(currentTrainerId)) {
          const data = await getTrainerById(currentTrainerId);
          setTrainerData(data);

          const trainers = data.trainers;
          setTrainers(trainers);

          const skillCenterEquipments = data.skillCenterEquipments;
          setSkillCenterEquipments(skillCenterEquipments);

          const skillCenterCourseContents = data.skillCenterCourseContents;
          setSkillCenterCourseContents(skillCenterCourseContents);
        }
      } catch (error) {
        toastr.error("An Error occured", "Please try again");
      }
    };

    fetchTrainerData();
  }, [currentTrainerId]);

  const [trainerData, setTrainerData] = useState(null);

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const styleClasses = {
    parentContainer: {
      marginTop: "100px",
      paddingBottom: "4rem",
      paddingLeft: largeScreen ? "80px" : "24px",
      paddingRight: largeScreen ? "80px" : "24px",
    },
    stepperContainer: {
      marginTop: "24px",
      maxWidth: "800px", // Customize this value as needed
      margin: "auto", // Center the stepper
    },
    labelContainer: {
      marginBottom: "40px",
    },
    labelText: {
      marginBottom: "5px",
    },
    formContainer: {
      marginTop: "30px",
    },
  };

  const steps = ["Step 1", "Step 2", "Step 3", "Step 4"];

  return (
    <Box>
      <Box display={"flex"} alignItems={"center"}>
        <Link to="/home/trainersmanagement/virtualApproval">
          <IconButton>
            <Iconify icon="ic:round-keyboard-arrow-left" />
          </IconButton>
        </Link>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ color: "rgb(33, 43, 54)" }}
        >
          Virtual Approval &gt;{" "}
          <span style={{ fontSize: "smaller", fontWeight: 600 }}>
            Trainer Details
          </span>
        </Typography>
      </Box>
      <LoadingOverlay
        active={trainerData === null}
        styles={{
          overlay: (base) => ({
            ...base,
            background: "rgba(0, 0, 0, 0.15)",
          }),
        }}
        spinner
        text="Fetching Data for You..."
      >
        <Card
          style={{
            marginTop: "10px",
            paddingBottom: "4rem",
            paddingLeft: largeScreen ? "50px" : "24px",
            paddingRight: largeScreen ? "50px" : "24px",
          }}
        >
          <Box mt={2}>
            {/* Include the FormStepper component here */}
            <Box
              style={{
                marginTop: "50px",
                marginBottom: "40px",
                maxWidth: "1000px",
                margin: "auto",
                paddingTop: "30px",
              }}
            >
              <AdminFormStepper activeStep={activeStep} steps={steps} />
            </Box>
            {/* Content inside the form stepper */}
            <Box style={{ maxWidth: "1000px", margin: "auto" }}>
              {activeStep === 0 && (
                <Step1Component
                  trainerData={trainerData}
                  styleClasses={styleClasses}
                  grayedOutStyles={grayedOutStyles}
                  handleNext={handleNext}
                />
              )}

              {activeStep === 1 && (
                <Step2Component
                  trainers={trainers}
                  skillCenterEquipments={skillCenterEquipments}
                  styleClasses={styleClasses}
                  handleBack={handleBack}
                  handleNext={handleNext}
                />
              )}

              {activeStep === 2 && (
                <Step3Component
                  trainers={trainers}
                  trainerData={trainerData}
                  skillCenterCourseContents={skillCenterCourseContents}
                  skillCenterEquipments={skillCenterEquipments}
                  styleClasses={styleClasses}
                  grayedOutStyles={grayedOutStyles}
                  handleNext={handleNext}
                  handleBack={handleBack}
                />
              )}

              {activeStep === 3 && (
                <Step4Component
                  trainers={trainers}
                  trainerData={trainerData}
                  skillCenterCourseContents={skillCenterCourseContents}
                  skillCenterEquipments={skillCenterEquipments}
                  styleClasses={styleClasses}
                  grayedOutStyles={grayedOutStyles}
                  Comment={Comment}
                  handleCommentChange={handleCommentChange}
                  handleBack={handleBack}
                  showErr={showCommentError}
                  showErr2={showComment2Error}
                  showErr3={showComment3Error}
                  removeErr={removeCommentError}
                  commentErr={commentErr}
                  textFieldName={textFieldName}
                />
              )}
            </Box>
          </Box>
        </Card>
      </LoadingOverlay>
    </Box>
  );
};

export default ViewTrainer;
